import { generateQuery } from './create-hooks';
import { Endpoints, generateAxios } from '@matap/shared';

export const useChatHistory = generateQuery(Endpoints.chats.user.history, (endpoint, payload) => ({
  queryKey: ['useChatHistory', payload.query],
  queryFn: () => generateAxios(endpoint, payload).then((r) => r.data),
  gcTime: 5 * 60 * 1000,
}));
